import './Home.css';
import React from 'react';
import HomeMediaCard from '../cards/homeMediaCard.js';
import buildingBusiness from '../assets/cardImages/homePageImages/buildingBusiness.gif';
import contactUs from '../assets/cardImages/homePageImages/contactUs.gif';
import dogewrites from '../assets/cardImages/homePageImages/dogeWrites.gif';
import teach from '../assets/cardImages/homePageImages/education-students.gif';
import productGif from '../assets/cardImages/homePageImages/product.gif';
import digitalMarketing from '../assets/cardImages/homePageImages/digitalMarketing.gif';
import bookOurService from '../assets/cardImages/homePageImages/bookOurService.gif';

class Home extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <div className="Home">
          <body className="Home-body">

          <div className="Home-card">
              <HomeMediaCard
                header=" Experience Software Development with Us! "
                description=" We deliver your vision to reality!"
                imageUrl={buildingBusiness}
                link='/softwaredevelopment'
                alt="Software Development" />
            </div>

            <div className="Home-card">
              <HomeMediaCard
                header=" How to do Digital Marketing? "
                description="Unlock Profits, Boost ROI: Your Digital Success Journey Starts Here!"
                imageUrl={digitalMarketing}
                link='/digitalmarketing'
                alt="Digital Marketing Services" />
            </div>
            
          <div className="Home-card">
              <HomeMediaCard
                header=" What We Sell "
                description=" We Sell Electrical & Electronic products"
                imageUrl={productGif}
                link='/products'
                alt="products" />
            </div>

            <div className="Home-card">
              <HomeMediaCard
                header=" What We Teach "
                description=" We Teach MEAN stack, MERN stack & CS101"
                imageUrl={teach}
                link='/course'
                alt="courses" />
            </div>

            <div className="Home-card">
              <HomeMediaCard
                header=" What We Write "
                description=" We write Technical articles on IEEE, DEV Community and Medium to feed the Tech Hunger  "
                imageUrl={dogewrites}
                link='/article'
                alt="articles" />
            </div>

            <div className="Home-card">
              <HomeMediaCard
                header=" What We Build "
                description="Transforming Ideas into Reality: Your Vision, Our Code"
                imageUrl={buildingBusiness}
                link='https://www.linkedin.com/in/danyson/details/projects/'
                alt="IT Projects" />
            </div>

            <div className="Home-card">
              <HomeMediaCard
                header="Book Our Service Thru LinkedIn"
                description="We are a technology consultancy that integrates strategy, design and software engineering for modern digital businesses"
                imageUrl={bookOurService}
                link='https://www.linkedin.com/services/page/a28237309a41682071/'
                alt="IT Consulting Services" />
            </div>

            <div className="Home-card">
              <HomeMediaCard
                header=" Send Us A Mail Now "
                description=" Are you ready to build your modern digital business with us? We are here to help you transform your business by meeting your Software requirements to digitalize your workplace "
                imageUrl={contactUs}
                link='mailto:danysontech@gmail.com'
                alt="Get in Touch" />
            </div>

            <div className="Home-trademarks">
              <p> &copy; Copyright 2024 &nbsp; All rights reserved</p>
              <p> Developed by Danyson &nbsp; </p>
            </div>
          </body>
        </div>
      </div>
    );
  }
}

export default Home;
